import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { logPageView } from '@/lib/service';
import ExistingBrandsLandingPageSignup from '@/components/ExistingBrandsLandingPage/Signup';

const ExistingBrandsSignup = ({}: NextPageWithLayout<any>) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Scale Your Brand With Pietra',
    });
  }, []);
  return <ExistingBrandsLandingPageSignup />;
};

ExistingBrandsSignup.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title="Save big & grow your brand | Pietra"
        description="Members-only factories, fulfillment services, marketing tools, and more — an average savings of 30-50%."
        url={`${WEBSITE_URL}/existing-brands`}
        image={`${STATIC_FILE_URL}/979cfc6803ccc39ed1d7d9c198c2e72c.png`}
      />
      <Layout structured={SEO_META[SEO_META_PAGES.EXISTING_BRANDS].jsonld({})}>{page}</Layout>
    </>
  );
};
export default ExistingBrandsSignup;
